const GET_REGION = 'GET_REGION';
const SET_REGION = 'SET_REGION';

export {
    GET_REGION,
    SET_REGION
};